import script from "./colorcardStockRectify..vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardStockRectify..vue?vue&type=script&setup=true&lang=js"

import "./colorcardStockRectify..vue?vue&type=style&index=0&id=48b230da&lang=scss&scoped=true"
import "./colorcardStockRectify..vue?vue&type=style&index=1&id=48b230da&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b230da"]])

export default __exports__